
import { Contract } from './contract-en';

export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
    'FOLLOW_UP_COMMUNICATIONS': 'Follow-Up Communications',
    'SEARCH': 'Search',
    'SELECT_LOCATION': 'Select Location',
    'SELECT_TC': 'Select TC',
    'TC': 'T C',
    'PATIENT_ID': 'Patient ID',
    'PATIENT_NAME': 'Patient Name',
    'TC_NAME': 'TC Name',
    'LOCATION': 'Location',
    'TRIGGER': 'Trigger',
    'DAYS_OVER_DUE': 'Days Over Due',
    'QUOTE_EXPIRATION': 'Quote Expiration',
    'CONTACT': 'Contact',
    'WELCOME_UP': 'Welcome to',
    'ACCESS_PORTAL': 'access portal',
    'LOGIN_TO_YOUR_ACCOUNT': 'Log into your account',
    'USERNAME': 'Username',
    'PASSWORD': 'Password',
    'LOGIN': 'Login',
    'FORGOT_PASSWORD': 'Forgot Password',
    'ORTHO_CATAPULT': 'OrthoCatapult',
    'MY_PROFILE': 'My Profile',
    'PERSONAL_DETAILS': 'Personal Details',
    'FIRST_NAME': 'First Name',
    'EMP_ID': 'EMP ID',
    'ROLE': 'Role',
    'PRIMARY_LOCATION': 'Primary Location',
    'LAST_NAME': 'Last Name',
    'EMAIL': 'Email',
    'DATE_OF_JOINING': 'Date of Joining',
    'ADDITIONAL_LOCATIONS': 'Additional Location',
    'GENDER': 'Gender',
    'DATE_OF_BIRTH': 'Date of Birth',
    'CONTACT_INFO_ADDRESS': 'Contact Info - Address',
    'PROFILE_PICTURE': 'Profile Picture',
    'UPDATE': 'Update',
    'CANCEL': 'Cancel',
    'EDUCATION_SPECIALITY': 'Education - Speciality',
    'ABOUT_ME': 'About Me',
    'BUILDING_NO': 'Building No',
    'STREET_NO': 'Street No',
    'STREET_NAME': 'Street Name',
    'STATE_PROVINCE': 'State/Province',
    'COUNTRY': 'Country',
    'ZIP_CODE_POSTAL_CODE': 'ZIP Code/Postal Code',
    'ALTERNATIVE_EMAIL_OPTIONAL': 'Alternative Email (Optional)',
    'PHONE_NUMBER': 'Phone Number',
    'PHONE_TYPE': 'Phone Type',
    'SETTINGS': 'Settings',
    'CHANGE_PASSWORD': 'Change Password',
    'CATEGORY_MANAGEMENT': 'Category Management',
    'SET_GOALS': 'Set Goals',
    'EDIT_GOALS': 'Update Goals',
    'PRICING': 'Pricing',
    'UNIVERSAL': 'Universal',
    'GEOGRAPHY': 'Geography',
    'PRACTICE_DEMOGRAPHICS': 'Practice Demographics',
    'PRACTICE_PROFILE': 'Practice Profile',
    'DASHBOARD_REPORTS': 'Dashboard Reports',
    'LANGUAGE': 'Language',
    'CURRENT_PASSWORD': 'Current Password',
    'NEW_PASSWORD': 'New Password',
    'CONFIRM_NEW_PASSWORD': 'Confirm New Password',
    'ENTER_CUSTOM_MESSAGE': 'Enter your custom message here',
    'THIS_CONTENT_ADD_TO_EMAIL': 'This content will be added to the email and send to the patient',
    'SEND_EMAIL': 'Send Email',
    'LOG_OUT': 'Log Out',
    'ARE_YOU_SURE_DELETE': 'Are you sure you want to delete?',
    'YES': 'Yes',
    'NO': 'No',
    'ADD_NEW_CATEGORY': 'Add New Category',
    'LIST_CATEGORY': 'Category List',
    'NEW_CATEGORY_NAME': 'New Category Name',
    'PARENT_CATEGORY_IF_HAVE': 'Parent Category If Have',
    'SELECT_CATEGORY': 'Select Category',
    'TREATMENT_COMPLEXITY': 'Treatment Complexity',
    'CUSTOM': 'Custom',
    'CUSTOM_TREATMENT_COMPLEXITY': 'Custom Treatment Complexity',
    'NAME_CUSTOM_TREATMENT_COMPLEXITY': 'Name Custom Treatment Complexity',
    'ENTER_NAME': 'Enter Name',
    'ADD': 'Add',
    'CLOSE': 'Close',
    'CATEGORY_ID': 'Category ID',
    'CATEGORY_NAME': 'Category Name',
    'PARENT_CATEGORY': 'Parent Category',
    'ACTION': 'Action',
    'SEND': 'Send',
    'DELETE': 'Delete',
    'OPTIONAL': 'Optional',
    'DASHBOARD': 'Dashboard',
    'GLOBAL': 'Global',
    'DATE_RANGE': 'Date Range',
    'MONTHLY': 'Monthly',
    'QUARTERLY': 'Quarterly',
    'YEARLY': 'Yearly',
    'CONSULTATIONS': 'Consultations',
    'CLOSE_RATE': 'Close Rate',
    'FULL_PAYMENT': 'Full Payment',
    'AT_HOME_STARTS': 'At-Home Starts',
    'TOTAL_DAYS_OVERDUE': 'Total Days Overdue',
    'SAME_DAY_START': 'Same Day Starts',
    'ACCEPTED_STARTS': 'Accepted Starts',
    'ACTION_ITEMS': 'Action Items',
    'NAME_OF_TC': 'Name of TC',
    'DAYS_OVERDUE': 'Days Overdue',
    'PATIENT_REFERRAL_LIST': 'Patient Referral List',
    'REFFERED_BY': 'Referred By',
    'BEST_CONTACT_METHOD': 'Best Contact Method',
    'OWNER': 'Owner',
    'DATE_OF_REFERRAL': 'Date of Referral',
    'PENDING_DAYS': 'Pending Days',
    'NEW_PRACTICES': 'NEW PRACTICES',
    'USERS_AROUND': 'Users around',
    'GLOBE': 'globe',
    'CASE_FEE_GENERATED': 'Case Fee Generated',
    'NEW_PRACTICE': 'New Practice',
    'CREATE_DEMO': 'Create Demo',
    'CASE_STUDY': 'Case study',
    'MANAGE': 'Manage',
    'PROMO_CODE': 'Promo Code',
    'VIEW': 'View',
    'REPORTS': 'Reports',
    'CONSULTATION': 'Consultation',
    'ACCEPTED_RATE': 'Accepted rate',
    'RED_DAYS': '"red" days',
    'OVERALL_STATISTICS': 'Overall statistics',
    'GRAPH': 'Graph',
    'COMMUNICATION': 'Communication',
    'SOME_ACTION': 'Some Action',
    'CATEGORY_BREAKDOWN': 'Category Breakdown',
    'CREATE_PATIENT_FILE': 'Create Patient File',
    'RECENT_PATIENT_FILES': 'Recent Patient Files',
    'ADD_NEW_PATIENT': 'Add New Patient',
    'CASE_TYPE': 'Initial Preference',
    'CREATE_CASE_STUDY': 'Create Case Study',
    'EDIT_CASE_STUDY': 'Edit Case Study',
    'SELECT_TREATMENT_GROUP': 'Select Treatment Group',
    'FIELD_REQUIRED': 'Field required',
    'CASE_STUDY_NAME': 'Case Study Name',
    'TREATMENT_DURATION': 'Treatment Duration',
    'PATIENT_AGE': 'Patient Age',
    'PHOTO_COURTESY': 'Photo Courtesy',
    'SELECT_TREATMENT_COMPLEXITY': 'Select Treatment Complexity',
    'AUXILIARIES_USED': 'Auxiliaries Used',
    'ADDITIONAL_NOTES': 'Additional Notes',
    'UPLOAD_PHOTOS': 'Upload Photos',
    'BEFORE': 'BEFORE',
    'AFTER': 'AFTER',
    'UPLOAD': 'Upload',
    'UPLOAD_TESTIMONIAL_VIDEO': 'Upload Testimonial Video',
    'ADD_VIDEO_LINKS': 'Add Video Link',
    'VIDEO_URL': 'add video url',
    'UPLOAD_EDUCATIONAL_VIDEO': 'Upload Educational Video',
    'SAVE_CASE_STUDY': 'Save Case study',
    'UPDATE_CASE_STUDY': 'Update Case Study',
    'ALLOCATE_SAMPLE_CASE_STUDIES': 'Allocate sample case studies',
    'SELECT_PRACTICE_NAME': 'Select Practice Name',
    'SHOW': 'Show',
    'ALLOCATE': 'Allocate',
    'SET_AS_TOP': 'Set as top',
    'ADD_TO_REFERRAL_ALBUM': 'Add to Referral Album',
    'REMOVE_FROM_TOP': 'Remove from Top',
    'REMOVE_FROM_REFERRAL_ALBUM': 'Remove from Referral Album',
    'VIEW_CASE_STUDY': 'View Case Study',
    'PRACTICE_STRUCTURE': 'Practice Structure',
    'PREV_YEAR_ANNUAL_START_PROVIDER': "Previous Year's Annual Starts Per Provider",
    'GEOGRAPHIC_MEDIAN_HOUSE_HOLD_INCOME': 'Geographic Median Household Income',
    'PREV_YEAR_PRACTICE_ANNUAL_START': "Previous Year's Practice Annual Starts",
    'OPTIONAL_PREV_YEAR_ALIGNER_SHARE': "Optional Previous Year's Overall Aligner Share",
    'SAVE_DEMOGRAPHICS': 'Save Demographics',
    'PRICING_SETTINGS': 'Pricing Settings',
    'MONTHS': 'Months',
    'PRICE': 'Price',
    'MINIMUM_DP': 'Minimum Down Payment',
    'MAXIMUM': 'Maximum',
    'EXTENTED_PAYMENTS': 'Extended Payments',
    'SAVE': 'Save',
    'PRACTICE_LOCATIONS': 'Practice Location(s)',
    'STREET_ADDRESS': 'Street Address',
    'ZIP_CODE': 'ZIP Code',
    'POSTAL_CODE': 'Postal Code',
    'CITY': 'City',
    'SAVE_LOCATIONS': 'Save Location',
    'EDIT_LOCATIONS': 'Update Location',
    'GOAL_TIME_FRAME': 'Goal Time frame',
    'CHOOSE_TC_DOCTOR': 'Choose TC/Doctor',
    'APPLY_TO_ALL': 'Apply to all',
    'GOALS': 'Goals',
    'CASE_STARTS': 'Case Starts',
    'HEIGHT': 'Height',
    'PIXEL': 'Pixel',
    'WIDTH': 'Width',
    'OR': 'or',
    'RATIO': 'ratio',
    'PRACTICE_NAME': 'Practice Name',
    'PRACTICE_LOGO': 'Practice Logo',
    'SUBSCRIPTION_PERIOD': 'Subscription Period',
    'FROM': 'From',
    'TO': 'to',
    'SUPER_ADMIN_COO_NAME': 'SuperAdmin / COO Name',
    'PRACTICE_ADMIN_CONTACT_NUMBER': 'Practice Admin Contact Number',
    'NUMBER_OF_LOCATION_SUBSCRIPTION': 'Number of Locations/Subscription',
    'UPGRADE': 'Upgrade',
    'CANCEL_AUTO_RENEWAL': 'Cancel Auto-Renewal',
    'PRACTICE_ADMIN_EMAIL': 'Practice Admin Email',
    'SAVE_PROFILE': 'Save Profile',
    'PRE_POPULATED': 'PrePopulated',
    'UNIVERSAL_PRICING_SETTINGS': 'Universal Pricing Settings',
    'EXTENDED_PAYMENT_INTREST': 'Extended Payment Interest',
    'PAY_IN_FULL_DISCOUNT': 'Pay In Full Discount',
    'PAY_IN_FULL_DISCOUNT_SETTINGS': 'Pay In Full Discount Settings',
    'DOWN_PAYMENT_DISCOUNT': 'Down Payment Discount',
    'LARGE_DOWN_PAYMENT_DISCOUNT_SETTINGS': 'Large Down Payment Discount Settings',
    'ADD_DOWN_PAYMENT_DISCOUNT': 'Enable Large Down Payment Discount',
    'ENABLE_LARGE_DOWN_PAYMENT_DISCOUNT': 'Enable Large Down Payment Discount',
    'MINIMUM_PATIENT_RESPONSIBILITY': 'Minimum % of Patient Responsibility Price',
    'DISCOUNT_RATE': 'Discount Rate',
    'TREATMENT_PLAN': 'Treatment Plan',
    'SEND_PLAN': 'Send Plan',
    'PRESENT_PLAN': 'Present Plan',
    'TREATMENT_GROUP': 'Treatment Group',
    'TREATMENT_CATEGORY': 'Treatment Category',
    'PROJECTED_TREATMENT_TIME': 'Projected Treatment Time',
    'RISK_RATING': 'Risk Rating',
    'MAXIMUM_EXTENDED_PAYMENT_INTREST': 'Maximum Extended Payment Interest',
    'ESTIMATED_INSURANCE_COVERAGE': 'Estimated Insurance Coverage',
    'ESTIMATED_INSURANCE': 'Estimated Insurance',
    'PAID_TO_PRACTICE': 'Paid to Practice',
    'PAID_TO_INSURED': 'Paid to Insured',
    'COURTESY_DISCOUNT': 'Courtesy Discount',
    'REFERRAL_DOCTOR': 'Referral Doctor',
    'TREATMENT_COORDINATOR': 'Treatment Coordinator',
    'INITIAL_TREATMENT_PREFERENCE': 'Initial Treatment Preference',
    'DOCTOR': 'Doctor',
    'PARENT_ORTHO_RELAPSE': 'Parent Ortho Relapse Candidate',
    'TREATMENT_OPTIONS': 'Treatment Options',
    'PLAN_PRICE': 'Plan Price',
    'MINIMUM_DOWN_PAYMENT': 'Minimum Down Payment',
    'MINIMUM_DOWN_FOR_DISCOUNT': 'Minimum Large Down Payment % For Discounts',
    'LARGE_DOWN_PAYMENT_DICOUNT_RATE': 'Large Down Pay Discount Rate',
    'MAXIMUM_EXTENDED_MONTHLY_PAYMENT': 'Maximum Extended Monthly Payments(EMP)',
    'ADDITIONAL_APPLIANCE_FEE': 'Additional Appliance Fee',
    'ACCELARATED_TREATMENT_FEE': 'Accelerated Treatment Fee',
    'CASE_STUDIES': 'Case Studies',
    'IMAGES': 'images',
    'VIDEO': 'video',
    'CREATED_ON': 'Created On',
    'VIEW_ALL': 'View All',
    'VIEW_LESS': 'View Less',
    'PAYMENT_PLAN_OVERVIEW': 'payment plan overview',
    'TOTAL_TREATMENT_COST': 'Total Treatment Cost',
    'COURTESY': 'Courtesy',
    'PATIENT_RESPONSIBILITY': 'Patient Responsibility',
    'PAYMENT_PLAN': 'Payment Plan',
    'DOWN_PAYMENT': 'Down Payment',
    'MONTHLY_PAYMENT': 'Monthly Payment',
    'NUMBER_MONTHLY_PAYMENT': 'Number Of Monthly Payments',
    'QUOTE_EXPIRATION_DATE': 'Quote Expiration Date',
    'DOWN_PAYMENT_RECIEVED': 'Down Payment Received',
    'DOWN_PAYMENT_DATE': 'Down Payment Date',
    'PAYMENT_SCHEDULE': 'Payment Schedule',
    'PRINCIPLE': 'Principle',
    'PAYMENT': 'Payment',
    'RATE': 'Rate',
    'INTEREST': 'Interest',
    'Max_EMP_INTEREST': 'Max EMP Interest',
    'PRACTICE_LOCATION': 'Practice Location',
    'MAX_EXTENDED_PAYMENTS': 'Maximum Extended Payments - Beyond Treatment Time',
    'CASE_STUDY_GALLLERY': 'Case Study Gallery',
    'PHOTOS': 'Photos',
    'PHOTOS_COURTESY_OF': 'Photos Courtesy of',
    'TESTIMONIAL_VIDEO': 'Testimonial Video',
    'EDUCATIONAL_VIDEO': 'Educational Video',
    'REFER_PATIENT': 'Refer Patient',
    'POWERED_BY_PATIENTCATAPULT': new Date().getFullYear() + ' Practice Catapult LLC.',
    'PATIENT_LAST_NAME': 'Patient Last Name',
    'PATIENT_FIRST_NAME': 'Patient First Name',
    'PATIENT_MIDDLE_NAME': 'Patient Middle Name',
    'PATIENT_CONTACT_NUMBER': 'Patient Contact Number',
    'PATIENT_EMAIL_ID': 'Patient Email ID',
    'SELECT_GENDER': 'Select gender',
    'CASE_CATEGORY_OBSERVED': 'Case Category Observed',
    'NOTES': 'Notes',
    'SUBMIT': 'Submit',
    'REMAINING': 'Remaining',
    'UNTIL': 'Until',
    'EXPIRES': 'Expires',
    'DAYS': 'Days',
    'LEFT_TO': 'Left to',
    'EXPIRE': 'expire',
    'CASE': 'case',
    'QUOTE': 'quote',
    'ESTIMATED_TREATMENT_LENGTH': 'Estimated Treatment Length',
    'OTHER_DISCOUNTS': 'Other Discounts',
    'TOTAL_PATIENT_RESPONSIBILITY': 'Total Patient Responsibility',
    'CHOOSE_A': 'Choose a',
    'TO_REDUCE_YOUR_MONTHLY_PAYMENTS': 'to reduce your monthly payments',
    'THAT_BEST_FITS_YOUR_BUDGET_BY_CHANGING': 'that best fits your budget by changing',
    'THE_TOTAL_NUMBER_OF_MONTHS': 'the total number of months',
    'DISCOUNTS': 'Discounts',
    'OF_MONTHS': 'Of Months',
    'ACCEPT': 'accept',
    'DECLINE': 'decline',
    'SORRY': 'Sorry!',
    'INVALID_URL': 'Invalid URL',
    'ORTHO_CALCULATOR': 'Calculator',
    'HEALTH_ID': 'Health ID',
    'DETAILS': 'Details',
    'REFERRAL_SOURCE': 'Referral Source',
    'RISK_CATEGORY': 'Risk Category',
    'SELECT_CASE': 'Select Case',
    'CONTACT_INFO': 'Contact Info',
    'ENTER_NAME_OF_THE_CONTACT': 'Enter Name of the Contact',
    'RELATIONSHIP': 'Relationship',
    'CREATE_TREATMENT_PALN': 'Create Treatment Plan',
    'PATIENT_FILES': 'Patient Files',
    'SEARCH_PATIENT': 'Search',
    'LAST_INITIAL': 'Last Initial',
    'CONTACT_NUMBER': 'Contact Number',
    'NAME_OF_CONTACT': 'Name of Contact',
    'ENTRIES': 'entries',
    'SHOWING': 'Showing',
    'OF': 'of',
    'VIEW_PATIENT_FILE': ' View Patient File',
    'ID': 'ID',
    'DOB': 'DOB',
    'EDIT_PATIENT': 'Edit Patient',
    'CREATE_NEW_TREATMENT_PLAN': 'Create New Treatment Plan',
    'PREVIOUS_TREATMENT_PLAN': 'Previous Payment Plan',
    'NOT_RECEIVED': 'Not Recieved',
    'TREATMENT_HISTORY': 'Treatment History',
    'TREATMENT': 'Treatment',
    'START_DATE': 'Start Date',
    'COST': 'Cost',
    'PLAN_ID': 'Plan ID',
    'ESTIMATED': 'Estimated',
    'FINISH_DATE': 'Finish Date',
    'ACTUAL': 'Actual',
    'NUMBER': 'Number',
    'NAME_OF': 'Name of',
    'NO_OF_LOCATIONS': 'Number of Locations',
    'DEFAULT_LANGUAGE': 'Default Language',
    'PRACTICE_EMAIL_OR_USERNAME': 'Practice email ID/ User name',
    'TEMPORARY_PASSWORD': 'Temporary Password',
    'SEND_ACCESS_DETAILS_TO': 'Send Access Details to',
    'TRYING_TO_REMOVE_PRACTICE': 'You are trying to permanently delete a practice',
    'TO_REMOVE': 'To delete',
    'PLEASE_ENTER': 'please enter',
    'AND_PRESS_CONFIRM': 'and press confirm button',
    'ENTER_THE_TEXT_HERE': 'Enter the text here',
    'CONFIRM': 'Confirm',
    'PRACTICE_CONTACT_NAME': 'Practice Contact Name',
    'SEARCH_PRACTICE': 'Search',
    'ADD_PRACTICE': 'Add Practice',
    'PRACTICE_ID': 'Practice ID',
    'CONTACT_PERSON': 'Contact Person',
    'SUBSCRIPTION_STARTED_ON': 'Subscription started on',
    'SUBSCRIPTION_ENDS_BY': 'Subscription ends by',
    'VIEW_PRACTICE': 'View Practice',
    'EDIT': 'Edit',
    'CREATE_NEW_REFERRING_DOCTOR': 'Create New Referring Doctor',
    'GP_DENTIST_DETAILS': 'Referring Doctor Details',
    'CLINIC_HOSPITAL_NAME': 'Clinic / Hospital Name',
    'REFERRAL_TYPE': 'Referral Type',
    'EMAIL_ID': 'Email',
    'SEARCH_REFERRING_DOCTOR': 'Search',
    'ADD_NEW_REFERRING_DOCTOR': 'Add New Referring Doctor',
    'REFERRAL_ID': 'Referral ID',
    'DOCTOR_FIRST_NAME': 'Dr. First Name',
    'DOCTOR_LAST_INITIAL': 'Dr. Last Initial',
    'DOCTOR_LAST_NAME': 'Dr. Last Name',
    'REF_TYPE': 'Ref. Type',
    'REFERRAL_ADDED_BY': 'Referral Owner',
    'EDIT_REFERRING_DOCTOR': 'Edit Referring Doctor',
    'DELETE_REFERRING_DOCTOR': 'Delete Referring Doctor',
    'RECORD_DELETE_CONFIRMATION': 'This record will be deleted from the list. Are you sure?',
    'PATIENT_LAST_INITIAL': 'Patient Last Initial',
    'DATE_REFERRED': 'Date Referred',
    'DAYS_PENDING': 'Days Pending',
    'DATE_CONTACTED': 'Date Contacted',
    'ASSIGN_TC': 'Assign TC',
    'ASSIGN': 'Assign',
    'TREATMENT_COORDINATOR_NAME': 'Treatment Coordinator Name',
    'SELECT_TREATMENT_CATEGORY': 'Select Treatment Category',
    'TREATMENT_CATEGORY_CREATED': 'Treatment Category added successfully',
    'SELECT_LANGUAGE': 'Select Language',
    'CONSULTATION_FOLLOW_UP_COMMUNICATIONS': 'Consultation Follow-Up Communications',
    'PAY_IN_FULL': 'pay-in-full',
    'SAME_DAY_STARTS': 'same day starts',
    'START_NOW': 'Start Now !',
    'OK': 'ok',
    'CROP_LOGO': 'Crop Your Logo',
    'MALE': 'Male',
    'FEMALE': 'Female',
    'NON_BINARY': 'Non-Binary',
    'ADD_USER': 'Add User',
    'EMPL_ID': 'Emp ID',
    'DATE_JOIN': 'Date of Join',
    'USER_MANAGEMENT': 'User Management',
    'LOCATION_ID': 'Location ID',
    'NAME': 'Name',
    'STREET': 'Street',
    'DELETE_LOCATION': 'Delete Location',
    'I_APPROVE_THE': 'I approve the',
    'TERMS_OF_SERVICE': 'terms of service',
    'PAY_WITH': 'Pay with',
    'STRIPE': 'stripe',
    'SIMPLE_PRICING': 'Simple Pricing. No Surprises.',
    'UPGRADE_OR_DOWNGRADE': 'Upgrade or downgrade anytime',
    'GET_DISCOUNT': 'Multi-Year Plans = Huge Savings',
    'SELECT': 'Select',
    'SUBSCRIPTION_FOR': 'Subscription for ',
    'OFF': 'off',
    'ANNUAL_SAVING': 'Annual Savings',
    'YEAR': 'Year',
    'ALL_LOCATIONS': 'All locations',
    'ALL_DEMOGRPAHICS': 'Demographics',
    'CREATE_SAMPLE_CASE_STUDY': 'Create Sample Case Study',
    'RE_ASSIGN_TC': 'Re-Assign TC',
    'POSITIVE_VALUE': 'Enter valid data',
    'ENGLISH': 'English',
    'SPANISH': 'Spanish',
    'FRENCH': 'French',
    'ADD_MESSAGE': 'Add Message',
    'USER_ROLE': 'User Role',
    'EMP_EMAIL_ID': "Emp. Email ID",
    'DATE_OF_JOIN': 'Date of Join',
    'INCOMPLETE_DETAILS': 'Incomplete Details',
    'TREATMENT_COMPLEXITY_NOT_SELECTED': 'Treatment Complexity not Selected',
    'CUSTOM_TREATMENT_CATEGORY_NOT_ENTERED': 'Custom Treatment Category not entered',
    'CATEGORY_NOT_CREATED': 'Failed to create Category',
    'CATEGORY_EDIT_SUCCESS': 'Category edited successfully',
    'CATEGORY_EDIT_FAIL': 'Failed to edit Category',
    'CATEGORY_DELETE_SUCCESS': 'Category deleted successfully',
    'CATEGORY_DELETE_FAIL': 'Failed to delete Category',
    'TC_UPDATE_SUCCESS': 'TC updated successfully',
    'TC_ASSIGN_SUCCESS': 'Assigned TC successfully',
    'TC_UPDATE_FAIL': 'Failed to update TC',
    'UPDATE_CONTACT_DETAIL_SUCCESS': 'Contacted date updated successfully',
    'UPDATE_CONTACT_DETAIL_FAIL': 'Failed to update details',
    'EMAIL_SEND_SUCCESS': 'Email sent Successfully',
    'EMAIL_SEND_FAIL': 'Failed to send email',
    'DOCUSIGN_LINK_SUCCESS': 'DocuSign linked successfully',
    'DOCUSIGN_LINK_ERROR': 'DocuSign link error',
    'NO_IMAGE_UPLOADED': 'No images uploaded',
    'IMAGES_UPLOADED': 'Images uploaded',
    'FILL_REQUIRED_DETAILS': 'Fill required details',
    'CASE_STUDY_CREATED': 'Case study created',
    'SOMETHING_WENT_WRONG': 'Something went wrong',
    'CASE_STUDY_EDIT_SUCCESS': 'Case Study edited successfully',
    'CASE_STUDY_ALLOCATED': 'Case Study allocated',
    'CASE_STUDY_ALLOCATION_FAIL': 'Case study allocation failed',
    'DEMOGRAPHIC_SAVE_SUCCESS': 'Practice demographic saved successfully',
    'DEMOGRAPHIC_SAVE_FAIL': 'Failed to save practice demographic details',
    'PRICING_LIST_UPDATE_SUCCESS': 'Pricing list updated successfully',
    'PRICING_LIST_UPDATE_FAIL': 'Pricing list update failed',
    'ALL_FIELDS_REQUIRED': 'All fields are required',
    'LOCATION_UPDATE_SUCCESS': 'Location Updated Successfully',
    'LOCATION_ADD_SUCCESS': 'Location Added Successfully',
    'GOAL_SAVE_FAIL': 'Failed to save goal',
    'LANGUAGE_UPDATED': 'Language Updated',
    'LANGUAGE_UPDATE_FAIL': 'Failed to update language',
    'PRACTICE_CREATE_SUCCESS': 'Practice created successfully',
    'PRACTICE_CREATE_FAIL': 'Failed to create practice',
    'PRACTICE_UPDATE_SUCCESS': 'Practice updated successfully',
    'PRACTICE_UPDATE_FAIL': 'Failed to update practice',
    'PRACTICE_DELETED': 'Practice deleted',
    'UNIVERSAL_PRICE_UPDATE_SUCCESS': 'Universal pricing list updated successfully',
    'PROVIDE_VALID_EMAIL': 'Please provide a valid email',
    'INCOMPLETE_REFERRAL_DETAILS': 'Incomplete Referal Details',
    'PATIENT_REFERRAL_CREATED': 'Patient referral created successfully',
    'PLAN_SEND_SUCCESS': 'Plan sent successfully',
    'FILL_REQUIRED_FIELD': 'Fill in required fields',
    'PATIENT_FILE_CREATE_SUCCESS': 'Patient file created successfully',
    'PATIENT_FILE_CREATE_FAIL': 'Failed to create patient file',
    'PATIENT_FILE_UPDATE_SUCCESS': 'Patient file updated successfully',
    'PATIENT_FILE_UPDATE_FAIL': 'Failed to update patient file',
    'EMAIL_NOT_VALID': 'Email ID not valid',
    'USERNAME_ALREADY_EXIST': 'Username already exist',
    'PROFILE_NOT_UPDATED': 'Profile details not updated',
    'PROFILE_UPDATED': 'Profile updated successfully',
    'REF_DOCTOR_CREATE_SUCCESS': 'Referral doctor created successfully',
    'REF_DOCTOR_DELETE_SUCCESS': 'Doctor details deleted successfully',
    'REF_DOCTOR_UPDATE_SUCCESS': 'Doctor details updated successfully',
    'DELETED': 'Deleted',
    'NOT_DELETED': 'Not deleted',
    'PASSWORD_UPDATE_SUCCESS': 'Password updated successfully',
    'PASSWORD_UPDATE_FAIL': 'Failed to update password',
    'PASSWORD_NOT_MATCH': 'Password does not match',
    'SELECT_TREATMENT_OPTION': 'Please select a treatment option',
    'TREATMENT_PLAN_SAVE_SUCCESS': 'Treatment plan saved successfully',
    'PLEASE_SELECT_CASE_STUDY': 'Please select a case study',
    'TREATMENT_PLAN_SENT_SUCCESS': 'Successfully sent treatment plan',
    'TREATMENT_PLAN_SENT_ERROR': 'Some error occured while sending plan',
    'INVALID_PARENT_CATEGORY': 'Invalid parent category',
    'CATEGORY_IS_IN_USE': 'Category is currently in use',
    'SUBSCRIPTION_REQUIRED_COO': 'You have not subscribed to any plans yet or your existing plan has expired!',
    'SUBSCRIPTION_REQUIRED': 'Please contact your Admin!',
    'SUBSCRIPTION_REQUIRED_ENTERPRISE': 'Please contact us at support@practicecatapult.com to request additional practice locations',
    'SUBSCRIBE_NOW': 'Subscribe Now',
    'LOGOUT': 'Logout',
    'USER_CREATE_SUCCESS': 'User created successfully',
    'USER_NOT_CREATED': 'User not Created',
    'USER_UPDATE_SUCCESS': 'User updated successfully',
    'USER_NOT_UPDATED': 'User not updated',
    'VIEW_USER': 'View User',
    'NO_DATA_FOUND': 'No data found',
    'INCORRECT_PASSWORD': 'Incorrect Current Password',
    'OTHER_LOCATION': 'Other Location',
    'INVALID_INPUT': 'Invalid Input',
    'UN_AUTHORIZED': 'You are not authorized, Please login',
    'SENT_EMAIL_TO_PATIENT': 'Email has been sent to the patient',
    'CASE_STUDY_UPDATED': 'Case study updated successfully',
    'CASE_STUDY_DELETED': 'Case study deleted',
    'CASE_STUDY_ASSIGNED': 'Case study assigned successfully',
    'CASE_STUDY_TOP_THREE_LIMIT': 'Top 3 case studies already set',
    'CASE_STUDY_THREE_REFERRAL_LIMIT': '3 case studies already added to referral album',
    'CASE_STUDY_PHOTOS_CREATED': 'Created case study photos',
    'CASE_STUDY_PHOTOS_DELETED': 'Case study photos deleted',
    'CASE_STUDY_PHOTO_UPDATED': 'Updated case study photo',
    'CASE_STUDY_PHOTO_DELETED': 'Deleted case study photo',
    'GOAL_CREATED': 'Goal saved successfully',
    'GOAL_UPDATED': 'Goal updated successfully',
    'GOAL_DELETED': 'Goal deleted successfully',
    'INVALID_EMPLOYEE_ID': 'Employee Id Invalid',
    'PATIENT_FILE_CREATED': 'Patient file created successfully',
    'PATIENT_FILE_UPDATED': 'Patient file updated successfully',
    'PATIENT_FILE_DELETED': 'Patient file deleted',
    'PATIENT_REFERRAL_UPDATED': 'Patient referral updated successfully',
    'PATIENT_REFERRAL_DELETED': 'Patient referral deleted',
    'PATIENT_REFERRAL_CONTACT_UPDATED': 'Patient referral contact updated successfully',
    'PATIENT_REFERRAL_NOT_FOUND': 'Patient referral not found',
    'INVALID_OWNER': 'Owner Invalid',
    'INVALID_PATIENT_FILE': 'Patient file invalid',
    'PRACTICE_CREATED': 'Practice created successfully',
    'PRACTICE_UPDATED': 'Practice updatedted successfully',
    'PRACTICE_LOCATION_CREATED': 'Created practice location',
    'PRACTICE_LOCATION_UPDATED': 'Updated practice location',
    'PRACTICE_LOCATION_DELETED': 'Deleted practice location',
    'PRACTICE_LOCATION_DEMOGRAPHIC_UPDATED': 'Practice demographic location updated',
    'DOCUSIGN_LINKED': 'Docusign linked',
    'PRICING_UPDATED': 'Pricing updated successfully',
    'PROMO_CODE_CREATED': 'Promo code created successfully',
    'UNIVERSAL_PRICING_UPDATED': 'Universal pricing updated successfully',
    'FOLLOW_UP_NOT_FOUND': 'Follow up not found',
    'FOLLOW_UP_CONTACT_UPDATED': 'Follow up contact updated successfully',
    'TREATMENT_PLAN_DELETED': 'Treatment plan deleted',
    'TREATMENT_PLAN_UPDATED': 'Treatment plan updated successfully',
    'TREATMENT_CATEGORY_UPDATED': 'Treatment category updated successfully',
    'TREATMENT_CATEGORY_DELETED': 'Treatment category deleted',
    'TREATMENT_GROUP_NOT_PROVIDED': 'Treatment group not provided',
    'TREATMENT_STARTED': 'Treatment started',
    'TREATMENT_DECLINED': 'Treatment declined',
    'USER_CREATED': 'User created successfully',
    'USER_UPDATED': 'User updated successfully',
    'USER_DELETED': 'User deleted',
    'USER_NOT_LOGGED_IN': 'User not logged in',
    'PASSWORD_CHANGED': 'Password changed',
    'GP_CREATED': 'GP created',
    'GP_DELETED': 'GP deleted',
    'GP_UPDATED': 'GP updated',
    'USERNAME_EXISTS': 'Username already exist',
    'USER_NOT_FOUND': 'User not found',
    'PASSWORD_RECOVERY_TOKEN_SENT': 'Password recovery token sent',
    'CARD_CREATED': 'Card created',
    'CARD_DELETED': 'Card deleted',
    'CARD_MARKED_AS_PRIMARY': 'Cared marked as primary',
    'CARD_NOT_ATTACHED': 'Card not attatched',
    'SUBSCRIPTION_CREATED': 'Subscription created',
    'TREATMENT_CATEGORY_CURRENTLY_IN_USE': 'Treatment category is currently in use',
    'INVALID_PROMO_CODE': 'Invalid promo code',
    'NO_PROMO_CODE': 'No promo code',
    'DECLINE_PLAN': 'Plan Declined',
    'PATIENT_MAIL_ID': 'Patient Mail ID',
    'PATIENT_PHONE_NUMBER': 'Patient Phone Number',
    'EDIT_PATIENT_FILE': 'Edit Patient File',
    'NEW_PATIENT_FILE': 'New Patient File',
    'EDIT_PRACTICE': 'Edit Practice',
    'ADD_AND_SET_GOALS': 'Add & Set Goals',
    'EDIT_USER': 'Edit User',
    'AUTO_RENEWAL': 'Auto-Renewal',
    'PRACTICE_NOT_SELECTED': 'Practice not selected',
    'CASE_STUDY_NOT_SELECTED': 'Case study not selected',
    'TREATMENT_LENGTH': 'Treatment Length',
    'RISK': 'Risk',
    'PATIENT_NOT_REFERRED': 'Patient not Referred',
    'PATIENT_REFERRED': 'Patient Referred',
    'USERS_IN': 'Users in',
    'EMAIL_PLAN': 'Email Plan',
    'VIEW_CASE_GALLERY': 'View Case Gallery',
    'ONLINE': 'Online',
    'MARKETING': 'Marketing',
    'PATIENT_REFERRAL': 'Patient Referral',
    'REFERRING_DOCTORS': 'Referring Doctors',
    'PROFESSIONAL_REFERRALS': 'Professional Referrals',
    'MOTHER': 'Mother',
    'FATHER': 'Father',
    'BOTH': 'Both',
    'SELECT_PARENT_ORTHO_RELAPSE_CANDIDATE': 'Select parent ortho relapse candidate',
    'CONTACT_FIRST_NAME': 'Contact First Name',
    'CONTACT_LAST_NAME': 'Contact Last Name',
    'GUARDIAN': 'Guardian',
    'PATIENT': 'Patient',
    'REFERRAL_GALLERY_LINK': 'Referral Gallery Link',
    'SLIDER_VIEW': 'Slider View',
    'NORMAL_VIEW': 'Normal View',
    'UPGRADE_SUBSCRIPTION': 'Upgrade Subscription to add more locations',
    'GO_TOSUBSCRIPTION': 'Go to Subscription',
    'CONTACT_METHOD': 'Contact Method',
    'NOT_VALID_URL': 'Provide a valid url',
    'YEAR_OF_BIRTH': 'Year of Birth',
    'SELECT_SUBSCRIPTION_PERIOD': 'Select Subscription Period',
    'SUBSCRIBE': 'Subscribe',
    'CLONE': 'Clone',
    'SELECT_CANDIDATE': 'Select Candidate',
    'ADD_TO_DEFAULT': 'Add to default',
    'REMOVE_FROM_DEFAULT': 'Remove from default',
    'CHANGE_REFERRER': 'Change Referrer',
    'REFERRER': 'Referrer',
    'REFERRER_CHANGE_SUCCESS': 'Referrer changed successfully',
    'CHANGE_TC': 'Change TC',
    'SELECT_TREATMENT_SUB_CATEGORY': 'Select Treatment Sub Category',
    'TREATMENT_SUB_CATEGORY': 'Treatment Sub Category',
    'RENAME_OPTION_D': 'Rename Option D',
    'NEW_NAME': 'New Name',
    'GET_QUOTE': 'Get Quote',
    'BUY_NOW': 'Buy Now',
    'SEND_MAIL': 'Send Mail',
    'PASSWORD_RESET_LINK': 'Password Reset link sent successfully',
    'INVALID_USERNAME': 'Invalid Username',
    'RESET_PASSWORD': 'Reset Password',
    'EDIT_CATEGORY': 'Edit Category',
    'TREATMENT_PLAN_UPDATE_SUCCESS': 'Treatment plan updated successfully',
    'PAY_NOW': 'Pay Now',
    'CARD_ADDED_SUCCESSFULLY': 'Card added successfully',
    'APPLY_TAX': 'Apply Tax',
    'NET_PRICE': 'Net Price',
    'VAT_IF_APPLICABLE': 'VAT (if applicable)',
    'FOR_ONE_YEAR': 'for one year',
    'ASSIGN_COLOR': 'Assign color',
    'REASSIGN_COLOR': 'Reassign color',
    'DATA_TO': 'data to ',
    'SELECT_GROUPS': 'Select Groups',
    'SUBSCRIPTION': 'Subscription',
    'STARTED_ON': 'Started on',
    'ENDS_ON': 'Ends on',
    'PAGE_NOT_FOUND': 'Page Not Found',
    'LOOKS_LIKE_GOT_LOST': 'Looks like you’ve got lost…',
    'PAGE_NOT_EXIST': 'The page you’re looking for doesn’t exist or has been moved.',
    'GO_HOME': 'GO HOME',
    'PRICE_GREATER_THAN_ZERO': 'Plan price should be greater than zero',
    'INSURANCE_COVERAGE_GREATER_THAN_PRICE': 'Estimated insurance coverage should be less than plan price',
    'COURTESY_DISCOUNT_GREATER_THAN_PRICE': 'Courtesy discount should be less than plan price',
    'PATIENT_RESPONSIBILITY_GREATER_THAN_ZERO': 'Patient Responsibility should be greater than zero',
    'RENAME_TREATMENT_SETTING_LABELS': 'Rename Treatment Setting Labels',
    'OPTION': 'Option',
    'RESTORE_DEFAULT': 'Restore Default',
    'PROMOCODE_MANAGEMENT': 'Promo Code Management',
    'CREATE_PROMOCODE': 'Create Promo Code',
    'CODE_LENGTH': 'Code Length',
    'CODE_FORMAT': 'Code Format',
    'ALPHANUMERIC': 'Alphanumeric',
    'NUMERIC': 'Numeric',
    'CODE_PREFIX': 'Code Prefix',
    'CODE_SUFFIX': 'Code Suffix',
    'VALID_FROM': 'Valid From',
    'VALID_TO': 'Valid To',
    'VALID_FOR': 'Valid for',
    'ALL_PACKAGES': 'All Packages',
    'VALID_FOR_SUBSCRIPTION': 'Valid for Subscription',
    'ONE_YEAR': 'One Year',
    'THREE_YEAR': 'Three Year',
    'FIVE_YEAR': 'Five Year',
    'DISCOUNT': 'Discount',
    'CREATE': 'Create',
    'PROMO_CODE_ALREADY_EXISTS': 'Promo code already exists',
    'PROMO_CODE_ADDED': 'Promo code added',
    'PROMOCODES': 'PROMO CODES',
    'PROMOCODE': 'Promo Code',
    'CODE_ID': 'Code Id',
    'APPLICABLE': 'Applicable',
    'GOAL_ID': 'Goal ID',
    'ROLE_TYPE': 'Role',
    'LOCATIONS': 'Locations',
    'TIME_FRAME': 'Time Frame',
    'CONSULTAIONS': 'Consultations',
    'GOAL_DELETE_ERROR': 'Failed to delete goal',
    'DELETE_GOAL': 'Delete Goal',
    'GOAL_UPDATE_FAIL': 'Failed To Update Goal',
    'APPLY': 'Apply',
    'VALUE_RANGE': 'Value should be in range',
    'SELECT_ATLEAST_ONE_TREATMENT_OPTION': 'Select at least one treatment option',
    'SELECT_TC_ERROR': 'Please select atleast one TC/Doctor',
    'DECLINE_PAYMENT_PLAN_CONFIRMATION': 'This treatment plan will be declined. Are you sure?',
    'UPDATE_CONTACTED_DATE_CONFIRMATION': 'Last contacted date will be updated. Are you sure?',
    'ADD_NEW_SUBCATEGORY': 'Add New Subcategory',
    'NEW_SUBCATEGORY_NAME': 'New Subcategory Name',
    'SUFFIX_PREFIX_LENGTH_GREATER': 'Suffix-Prefix length should be less than code length ',
    'HISTORIC_DATA': 'Historical Data',
    'WRONG_CAPTCHA': 'Wrong Captcha',
    'PAYMENT_SUCCESS': 'Payment success',
    'PAYMENT_FAILED': 'Payment failed',
    'ADD_HISTORICAL_DATA': 'Add Historical Data',
    'EDIT_HISTORICAL_DATA': 'Edit Historical Data',
    'NUMBER_OF_CONSULTATIONS': '# of Consultations',
    'NUMBER_OF_SIGNED_CONTRACT': '# of Signed Contracts',
    'CLEAR': 'Clear',
    'SAVE_AND_ADD_ANOTHER': 'Save & add another',
    'MONTH': 'Month',
    'SELECT_MONTH': 'Select Month',
    'SELECT_YEAR': 'Select Year',
    'ADD_ACCOUNT': 'Add Account',
    'ENTERPRISE_ACCOUNTS': 'Enterprise Accounts',
    'CONTRACT_PERIOD': 'Contract Period',
    'ANNUAL_PAYMENT_DATE': 'Annual Payment Date',
    'GRACE_PERIOD': 'Grace Period',
    'ENTERPRISE_ACCOUNT': 'Enterprise Account',
    'NEXT_ANNUAL_PAYMENT_DATE': 'Next Annual Payment Date',
    'CONTACT_EMAIL_ID': 'Contact Email ID',
    'INVOICE_MAIL_ID': 'Invoice Mail ID',
    'BILLING_ADDRESS': 'Billing Address',
    'UNIT_APARTMENT_NUMBER': 'Unit/Apartment Number',
    'STATE': 'State',
    'PROVINCE': 'Province',
    'SAME_AS_CONTACT_MAIL': 'Same as contact mail',
    'ENTERPRISE_CREATE_SUCCESS': 'Enterprise created successfully',
    'ENTERPRISE_UPDATE_SUCCESS': 'Enterprise updated successfully',
    'ENTERPRISE_DELETED': 'Enterprise deleted',
    'LENGTH_EXCEEDED': 'Length limit exceeded',
    'ENTERPRISE_USERS': 'Enterprise users',
    'MAILING_ADRESS': 'Mailing Address',
    'UNIT_NO': 'Unit No',
    'PARENT/GUARDIAN': 'Parent/Guardian',
    'PARENT': 'Parent',
    'ORDER': 'Order',
    'EXISTING_PATIENT_OR_FAMILY': 'Existing Patient/ Family?',
    'FAMILY': 'Family',
    'EMAIL_TEMPLATE': 'Email Templates',
    'CREATE_EMAIL': 'Create Email',
    'NEW_MESSAGE': 'New Message',
    'SUBJECT': 'Subject',
    'DATE': 'Date',
    'TIME': 'Time',
    'AGE': 'Age',
    'EXISTING_FAMILY_OR_PATIENT': 'Existing Family / Patient?',
    'CLEAR_FILTERS': 'Clear Filters',
    'HISTORY_ADD_SUCCESS': 'Historical data added successfully',
    'HISTORY_UPDATE_SUCCESS': 'Historical data updated successfully',
    'HISTORY_DELETE_SUCCESS': 'Historical data deleted successfully',
    'TREATMENT_CATEGORY_NAME_ALREADY_EXISTS': 'Treatment category name already exists',
    'CATEGORY_ORDER': 'Category Order',
    'SUBCATEGORY_ORDER': 'Subcategory Order',
    'PREVIOUS_MAIL': 'Previous Mail',
    'PREVIEW': 'Preview',
    'ENTER_SUBJECT': 'Enter a subject',
    'MAIL_SENT': 'Mail sent',
    'CC': 'Cc',
    'BCC': 'Bcc',
    'BACK': 'Back',
    'MAKE_PAYMENT': 'Make Payment',
    'SELECT_OR_CREATE_CARD': 'Select or create card',
    'ADD_CARD': 'Add Card',
    'INVALID_DATE': 'Invalid Date',
    'DASHBOARD_DISPLAY_REPORT': 'Dashboard Display Reports',
    'SELECT_THREE_REPORTS': 'Select the reports to be displayed in the dashboard',
    'REPORT': 'Report',
    'FIRST': 'First',
    'SECOND': 'Second',
    'THIRD': 'Third',
    'ALL_PATIENTS': 'All Patients',
    'ENTER_TO_ADDRESS': 'Enter to address',
    'PLAN_CREATED': 'Plan Created',
    'PLAN_ACCEPTED': 'Plan Accepted',
    'STRIPE_LINK_SUCCESS': 'Stripe link success',
    'STRIPE_LINK_ERROR': 'Stripe link failure',
    'SETUP_DOCUSIGN': 'Setup Docusign',
    'CONNECT_WITH_STRIPE': 'Connect with Stripe',
    'DOCUSIGN_ID': 'DocuSign ID',
    'STRIPE_ID': 'Stripe ID',
    'MINIMUM_DOWN_FOR_DISCOUNT_%': 'Minimum Large %',
    'NO_PREFERENCE': 'No Preference',
    'TREATMENT_MODALITY': 'Treatment Modality',
    'CURRENCY': 'Currency',
    'SUITE_NO': 'Suite No',
    'MINIMUM_AMOUNT_FOR_DISCOUNT': 'Min Amount For Discount',
    '%_PATIENT_RESPONSIBILITY': '% of Patient Responsibility',
    'SELECT_TREATMEN_MODALITY': 'Select Treatment Modality',
    'INITIAL_PAYMENT': 'Initial Payment',
    'MONTHLY_PAYMENT_DEDUCTED_AUTOMATICALLY': 'Monthly Payments Will Be Debited Automatically',
    'PASSWORD_LENGTH_ERROR': 'Password length should be atleast six characters',
    'INVALID_NUMBER': 'Invalid phone number',
    'ADD_CONTRACT': 'Add Contract',
    'ENTER_PASSWORD': 'Enter your password',
    'INVALID_PASSWORD': 'Password incorrect',
    'LAST_ACCESSED': 'Last accessed',
    'LAST_MAIL_SENT': 'Last mail sent',
    'CONTRACT_DECLINED': 'Contract Declined',
    'DOWN_PAYMENT_GREATER_THAN_ZERO': 'Minimum down payment should be greater than zero',
    'QUOTE_TRIGGER_UPDATED': 'Quote and trigger updated',
    'TRIGGER_GREATER_THAN_ZERO': 'Trigger should be greater than zero',
    'TRIGGER_LESS_THAN_QUOTE_VALIDITY': 'Trigger should be less than quote validity',
    'PAYMENT_METHOD': 'Payment Method',
    'MARK_AS_READ': 'Mark as read',
    'NO_NOTIFICATIONS': 'No notifications',
    'PAY_IN_FULL_DISCOUNT_RATE': 'Pay in Full Discount Rate',
    'CUSTOM_CONTRACTS': 'Custom Contracts',
    'DOCISIGN_NOT_UPDATED': 'Docusign not updated',
    'UPLOAD_A_PDF_FILE': 'Upload a pdf file',
    'ADD_TAGS': 'Add Tags inside pdf',
    'LOCATION_IN_USE': 'Cannot delete. Location in use',
    'LOCATION_DELETED': 'Location deleted successfully',
    'PRACTICE_ACTIVE': 'Cannot delete. Practice in active',
    'ENTERPRISE_ACTIVE': 'Cannot delete. Enterprise in active',
    'ADD_REFERRAL_DOCTOR': 'Add New Referring Doctor',
    'MINIMUM_DOWN_PAYMENT_FOR_DISC_BASED_PATIENT_REPONSIBILITY': 'Minimum Down Payment For Discount - Based on Patient Responsibility',
    'ALL_TRIGGER_FIELDS_REQUIRED': 'Enter all trigger days',
    'ENTER_QUOTE_VALIDITY': 'Enter quote validity',
    'COLOR_NOT_SELECTED': 'Please select color',
    'INVALID_BIRTH_YEAR': 'Please enter a valid year of birth',
    'GOALS_AND_ACHIEVEMENTS': 'Goals & Achievements',
    'HELLO': 'Hello',
    'YOU_HAVE_ACHIEVED': 'You have achieved',
    'YOUR': 'Your',
    'DASHBOARD_ REPORTS_CHANGED': 'Dashboard Reports Changed',
    'OKAY': 'Okay',
    'DOWN_PAYMENT_LESS_THAN_PRICE': 'Down Payment should not exceed plan price',
    'DOWN_PAYMENT_LESS_THAN_PATIENT_RESPONSIBILITY': 'Down Payment should not exceed patient responsibility',
    'SELECT_CARD': 'Select Card',
    'ALL_GROUPS': 'All Groups',
    'GOAL': 'Goal',
    'COMMUNICATION_HISTORY': 'Communication History',
    'CONTACTED_METHOD': 'Contacted Method',
    'SL_NO': 'Serial No',
    'TIME_CONTACTED': 'Time Contacted',
    'SHOW_REFERRAL_GALLERY_LINK': 'Show referral gallery link',
    'CHOOSE_FILE': 'Choose File',
    'UPLOAD_COMPOSITE_PHOTOS': 'Upload Composite Photos',
    'COMPOSITE_PHOTOS': 'Composite Photos',
    'CLICK_TO_VIEW': 'Click to view',
    'CROP_IMAGE': 'Crop Image',
    'MAX_TREATMENT_OPTIONS_ALLOWED': 'Maximum 3 treatment options allowed',
    'PAYMENT_OPTIONS': 'Payment Options',
    'CHOOSE_TREATMENT_OPTION': 'Choose Treatment Option',
    'ESTIMATED_TREATMENT_DURATION': 'Estimated Treatment Duration',
    'TRADEMARK_AND_OWNERSHIP': 'All trademarks, trade names, product names and logos appearing on the site are the property of their respective',
    'OWNERS': 'owners.',
    'IS_A_REGISTERED_TRADEMARK_OF': 'is a registered trademark of',
    'IS_A_TRADEMARK_OF': 'is a trademark of',
    'AT_OFFICE': 'At Office',
    'AT_HOME': 'At Home',
    'STRIPE_PROFILE': 'Stripe Profile',
    'DOCUSIGN_PROFILE': 'DocuSign Profile',
    'PAYMENT_OPTIONS_UPDATED': 'Payment options updated',
    'IN_OFFICE': 'In-Office',
    'SCHEDULE_CONSULTATION': 'Schedule Consultation',
    'MESSAGE_SEND_SUCCESS': 'Message sent successfully',
    'MESSAGE_SEND_FAIL': 'Failed to send Message',
    'ENTER_MESSAGE': 'Enter Message',
    'SEND_MESSAGE': 'Send Message',
    'PROCEED_TO_DOCUSIGN': 'Proceed to Docusign',
    'BILLING_ADDRESS_UPDATED': 'Billing address updated',
    'YEARS': 'Years',
    'AUTO_RENEW_SUBSCRIPTION': 'Auto Renew Subscription',
    'RENEWAL_DATE': 'Renewal Date',
    'LOCATION_USED': 'Location Used',
    'LOCATIONS_USED': 'Locations Used',
    'LOCATION_AVAILABLE': 'Location Available',
    'LOCATION_ADDED': 'Location added',
    'LOCATION_NOT_ADDED': 'Location not added',
    'CART_OVERVIEW': 'Cart Overview',
    'ACCOUNT': 'Account',
    'LEGAL': 'Legal',
    'PRACTICE': 'Practice',
    'ADDRESS': 'Address',
    'CONFIRM_PASSWORD': 'Confirm Password',
    'STEPS': 'Steps',
    'COMPLETE': 'Complete',
    'MAKE': 'Make',
    'VERIFY': 'Verify',
    'INVALID_CONTACT_NO': 'Invalid contact number',
    'SIGNUP_FAILED': 'Signup failed',
    'CONGRATS': 'Congrats',
    'SENT_VERIFICATION_MAIL_TO': 'We have send a verification link to the mail',
    'VERIFY_ACCOUNT': 'We just need to verify your account before you can go to next step',
    'RESEND': 'Resend',
    'ACCOUNT_NOT_VERIFIED': 'Account not verified',
    'LOCATION_LIMIT_EXCEEDED': 'Location limit exceeded for selected practice structure',
    'DELETE_PROTECTED': 'Failed to delete patient file. Associated treatment plans exists',
    'LOCATIONS_AVAILABLE': 'Location Available',
    'VERIFICATION_ERROR': 'Email verification failed',
    'VERIFICATION_SUCCESS': 'Email verified successfully',
    'VERIFICATION_FAILURE': 'Email Address Verification Failure',
    'AUTO_RENEWAL_UPDATED': 'Auto renewal updated',
    'TOTAL_INTEREST': 'Total Interest',
    'PAYMENT_SUMMARY': 'Payment Summary',
    'APPROVE': 'Approve',
    'PLEASE_LOGIN_TO_ACCESS': 'Please log in to access treatment plan and ortho gallery',
    'PAY_IN_FULL_DISCOUNT_RATE_LESS_ERROR': "Pay in full discount rate sholud not be less than downpayment discount",
    'CLONE_CASE_STUDY': 'Clone Case Study',
    'BUY': 'Buy',
    'VIEW_COMMUNICATION_HISTORY': 'View Communication History',
    'UPDATE_DEMOGRAPHICS': 'Update Demographics',
    'DEMOGRAPHIC_UPDATE_SUCCESS': 'Practice demographic updated successfully',
    'DEMOGRAPHIC_UPDATE_FAIL': 'Failed to update practice demographic details',
    'SHOW_HISTORY': 'Show History',
    'HIDE_HISTORY': 'Hide History',
    'REFERRING_DOCTOR_INFORMATION': 'Referring Doctor Information',
    'PRINCIPAL': 'Principal',
    'BALANCE': 'Balance',
    'LEGAL_DISCLAIMER': 'Legal Disclaimer',
    'SUBSCRIPTION_PAYMENT_INFORMATION': 'Subscription Payment Information',
    'CARD_ON_FILE': 'Card On File',
    'EXPIRATION_DATE': 'Expiration Date',
    'UPDATE_PAYMENT_INFORMATION': 'Update Payment information',
    'SELECT_DEFAULT_CARD': 'Select Default Card',
    'MAKE_AS_DEFAULT': 'Make as Default',
    'DEFAULT_CARD_UPDATED': 'Default card updated',
    'REFERRING_DOCTOR': 'Referring Doctor',
    'REFERRING_TYPE': 'Referring Type',
    'SUBSCRIPTION_LENGTH': 'Subscription Length',
    'PACKAGE': 'Package',
    'BILL_MONTHLY': 'Bill Monthly',
    'BILL_ANUALLY': 'Bill Annually',
    'SUBSCRIPTION_UPDATED': 'Subscription updated',
    'PATIENT_PAYMENT_DETAILS': 'Patient Payment Details',
    'TREATEMENT_STARTED_ON': 'Treatment Started on',
    'FIRST_PAYMENT': 'First Payment',
    'NEXT_PAYMENT': 'Next Payment',
    'TREATEMENT_COST': 'Treatment Cost',
    'BALANCE_AMOUNT': 'Balance Amount',
    'PAYMENT_DETAILS': 'Payment Details',
    'DOWN_PAYMENT_RECEIVED': 'Down Payment Received',
    'TOTAL_PAYMENT': 'Total Payment',
    'STATUS': 'Status',
    'SUCCESS': 'Success',
    'FAILED': 'Failed',
    'UPCOMING': 'Upcoming',
    'RETRY': 'Retry',
    'RECEIVED_OFFLINE': 'Received Offline',
    'PAYMENT_UPDATED': 'Payment Updated Successfully',
    'FIND_YOUR_PAYMENT_DETAILS': 'Find your Payment Details',
    'AMOUNT': 'Amount',
    'PAYMENT_CARD_INFORMATION': 'Payment Card Information',
    'CARD_NUMBER': 'Card Number',
    'ADD_PAYMENT_INFORMATION': 'Add Payment information',
    'CHANGE_CARD': 'Change card',
    'PAYMENT_TYPE': 'Payment Type',
    'DEMO_SUBSCRIPTION_MESSAGE': '(Will be updated on Renewal)',
    'TREATMENT_LENGTH_GREATER_THAN_ZERO': 'Treatment length should be greater than zero',
    'TREATMENT_LIMITED_LENGTH_GREATER_THAN_ZERO': 'LIMITED treatment length should be greater than zero',
    'CLONE_CONFIRMATION': 'Are you sure you want to clone',
    'GLOBALLY': 'globally',
    'FOR': 'for',
    'DONE': 'Done',
    'TERMS_LICENSE_CONTENT_USE': 'Terms of Licensee Content Use',
    'LICENSEE_CONTENT_PERMISSIONS': 'Licensee Content & Permissions',
    'PATIENT_GUARDIAN_TALENT_RELEASES': 'Patient & Guardian Talent Releases',
    'SHARING_LICENSEE_CONTENT': 'Sharing Licensee Content',
    'LICENSEE_CONTENT_RESPONSIBILITIES': 'Licensee Content Responsibilities',
    'LICENSORS_CONTENT': 'Licensor’s Content',
    'COPYRIGHT': 'Copyright',
    'DISCLAIMER_TEXT1': Contract.DISCLAIMER_TEXT_PAR1,
    'DISCLAIMER_TEXT2': Contract.DISCLAIMER_TEXT_PAR2,
    'DISCLAIMER_AGREED': Contract.DISCLAIMER_AGREED,
    'LICENSE_LINK': Contract.LICENSE_LINK,
    'LICENSEE_CONTENT_PAR1': Contract.LICENSEE_CONTENT_PAR1,
    'LICENSEE_CONTENT_PAR2': Contract.LICENSEE_CONTENT_PAR2,
    'PATIENT_GUARDIAN_TALENT_RELASES_PAR1': Contract.PATIENT_GUARDIAN_TALENT_RELASES_PAR1,
    'PATIENT_GUARDIAN_TALENT_RELASES_PAR2': Contract.PATIENT_GUARDIAN_TALENT_RELASES_PAR2,
    'SHARING_LICENSE_CONTENT_PAR1': Contract.SHARING_LICENSE_CONTENT_PAR1,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR1': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR1,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR2': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR2,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR3': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR3,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR4': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR4,
    'LICENSORS_CONTENT_PAR1': Contract.LICENSORS_CONTENT_PAR1,
    'COPYRIGHT_CONTENT_PAR1': Contract.COPYRIGHT_CONTENT_PAR1,
    'COPYRIGHT_AGENT': 'Copyright Agent',
    'PRACTICE_CATAPULT_LLC': 'Practice Catapult LLC',
    'PRACTICE_ADRRESS_1': '9790 Gratiot Rd, Suite 1',
    'PRACTICE_ADRRESS_2': 'Saginaw, Michigan 48609',
    'SUBSCRIPTION_PRICING': 'Subscription Pricing',
    'SUBSCRIPTION_PRICES_UPDATED': 'Subscription prices updated',
    'CONTACT_ADMIN': 'Contact Admin',
    'TO_DECLINE': 'To decline',
    'RENEWAL': 'Renewal',
    'CURRENT': 'Current',
    'RESEND_PASSWORD': 'Resend Password',
    'SURVEY_MONKEY_URL': 'Survey Monkey URL',
    'ADD_ADDITIONAL_LOCATIONS': 'Add Additional Location',
    'YOUR_SUBSCRIPTION': 'Your Subscription',
    'GET_STARTED': 'GET STARTED',
    'PROCEED': 'PROCEED',
    'NO_OF_LOCATIONS_GREATER_THAN_CURRENT': 'No of locations should not be less than current value',
    'IMAGE_SIZE_GREATER_THAN_2MB': 'Image size should not be greater than 2 MB',
    'MY_CART': 'My Cart',
    'YOUR_PURCHASE': 'Your Purchase',
    'PLAN': 'Plan',
    'TREATMENT_APPROVAL_LIST': 'Treatment Approval List',
    'EXPIRES_AT': 'Expires At',
    'APPROVED': 'Approved',
    'WAITING': 'Waiting',
    'WAITING_FOR_APPROVAL': 'Waiting For Approval',
    'ACTIVATE': 'Activate',
    'DEACTIVATE': 'Deactivate',
    'USER_ACTIVATED': 'User Activated',
    'USER_DEACTIVATED': 'User Deactivated',
    'EMAIL_WAITING_MESSAGE': 'You will recieve an email from us once your contract is approved.',
    'DEMO_CASE_STUDY': 'Demo case study',
    'FOLLOW_UP': 'Follow-up',
    'REFERRAL': 'Referral',
    'INITIAL_DOWN_PAYMENT': 'Initial Down Payment',
    'BALANCE_REMAINING': 'Balance Remaining',
    'AMOUNT_DUE': 'Amount Due',
    'ACCESS_HISTORY': 'Access History',
    'RESPONSIBLE_PARTY_CONTACT_INFO': 'Responsible Party Contact Info',
    'RESPONSIBLE_PARTY_DOB': 'Responsible Party Date of Birth',
    'QUOTE_EXPIRATION_DAYS': 'Quote Expiration Days',
    'APPLY_FILTER': 'Apply Filter',
    'CHANGE_FILTER': 'Change Filter',
    'QUOTE_EXPIRATION_DAY_LOWER_LIMIT_GREATER_THAN_UPPRER_LIMIT': 'Expiration day upper limit should be greater than lower limit',
    'FILTER_APPLIED': 'Filter applied successfully',
    'NO_PATIENTS_FOUND': 'No patient found',
    'UPLOAD_DOCUMENT': 'Please upload contract document to proceed further.',
    'CONTRACT_LIST': 'Contract List',
    'INITIAL_VIEW': 'Initial View',
    'SELECT_INITIAL_VIEW': 'Select Initial View',
    'CREATED_AT': 'Created at',
    'HIDE_OFFICE_PAYMENT': 'Hide office payment',
    'GALLERY_LINK': 'Gallery Link',
    'INSURANCE_PLAN_MANAGEMENT': 'Insurance Plan Management',
    'ADD_INSURANCE_PLAN': 'Add Insurance Plan',
    'INSURANCE_PLANS': 'Insurance Plans',
    'ADD_NEW_PLAN': 'Add New Insurance Plan',
    'EDIT_PLAN': 'Edit Insurance Plan',
    'INSURANCE_PLAN_ADDED': 'Insurance plan added successfully',
    'INSURANCE_PLAN_EDITED': 'Insurance plan edited successfully',
    'INSURANCE_PLAN_DELETED': 'Insurance plan deleted successfully',
    'INSURANCE_PLAN': 'Insurance Plan',
    'SET_INSURANCE_PLAN': 'Set Insurance Plan',
    'COPY': 'Copy',
    'LINK_COPIED': 'Link Copied',
    'THANK_YOU': 'Thank You',
    'CONTRACT_NOW_PENDING': "Contract Now Pending Practice's Signature",
    'RECEIVE_EMAIL_NEXT_WORKING_DAY': 'You should receive an email within the next business day.',
    'PLEASE_ENTER_ACCESS_CODE': 'Please Enter Your ACCESS CODE',
    'TO_VIEW_PLAN': 'To View Your Treatment & Payment Plan',
    'ACCESS_CODE': 'Access Code',
    'LAST_DIGITS_OF_PHONE_NUMBER': 'Last 4 Digits of Your Phone Number',
    'ENTER_YPUR_ACCESS_CODE': 'Enter Your Access Code',
    'BILLING_DEPARTMENT_EMAIL': 'Billing Department Email',
    'RECEIVED': 'Received',
    'BEST_VIEWED': 'Best viewed with',
    'PENDING_TREATMENT_PLAN_APPROVALS': 'Pending Treatment Plan Approvals',
    'FAILED_PAYMENTS': 'Failed Payments',
    'SUCCESSFUL_PAYMENTS': 'Successful Payments',
    'TAX_FEE': 'Tx Fee',
    'DUE_DATE': 'Due Date',
    'DAYS_PAST_DUE': 'Days Past Due',
    'AMOUNT_PAST_DUE': 'Amount Past Due',
    'PAYMENT_DATE': 'Payment Date',
    'METHOD': 'Method',
    'GROUP': 'Group',
    'GOOGLE_CHROME': 'Google Chrome',
    'PREFERRED_CONTACT_METHOD': 'Preferred Contact Method',
    'PREFERRED_CONTACT': 'Preferred Contact',
    'SAVE_PRICE_CONFIRMATION_GLOBAL': 'Global settings will override all location pricing settings. Are you sure you want to save?',
    'SAVE_PRICE_CONFIRMATION': 'Are you sure you want to save?',
    'DATA': 'data',
    'MONTHLY_PAYMENT_DATE': 'Monthly Payment Date',
    'PRACTICE_INACTIVE_PLEASE_CONTACT': 'Practice not in active. Please contact your practice admin.',
    'IN_OFFICE_PAYMENTS': 'In-Office Payments',
    'ACCOUNT_STATUS': 'Account Status',
    'REFERRAL_GALLERY': 'Referral Gallery',
    'ACTIVE': 'Active',
    'INACTIVE': 'Inactive',
    'PRACTICE_ACCOUNT_INACTIVE': "Practice's Account is Inactive",
    'PRACTICE_ACCOUNT_INACTIVE_DESCRIPTION': 'Please have your Practice Admin renew your subscription or update your payment information immediately.',
    'MIDDLE_NAME': 'Middle Name',
    'NICKNAME': 'Nickname',
    'CANCEL_TRACKING': 'Cancel Tracking',
    'TREATMENT_PLAN_DELETE_CONFIRMATION': 'The treatment plan will be deleted. Are you sure?',
    'DOWNLOAD': 'Download',
    'DOCUSIGN_DOWNLOAD_DESC': 'Do you want to download the DocuSign® contract?',
    'TREATMENT_PLAN_DELETE_SUCCESS': 'Treatment plan deleted successfully',
    'TRACKING_CANCELLED': 'Communication tracking cancelled successfully',
    'CONTACT_MIDDLE_NAME': 'Contact Middle Name',
    'CANCEL_EMAIL_TRACKING': 'The triggered email from the system will be cancelled. Are you sure?',
    'CANCELLED_TRACKING': 'Tracking cancelled',
    'TREATMENT_EXPIRED': 'Treatment expired',
    'TREATMENT_NOT_STARTED': 'Treatment not started',
    'POWERED_BY_ORTHOGALLERY': 'Powered by OrthoGallery',
    'POWERED_BY_ORTHOCALCULATOR': 'Powered by OrthoCalculator',
    'POWERED_BY': 'Powered by ',
    'ORTHOCATAPULT': 'OrthoCatapult®',
    'LIMITED_TREATMENT_OPTION': 'Limited Treatment Option',
    'PROJECTED_LIMTED_TREATMENT_TIME': 'Projected LIMITED Tx Time',
    'COMPREHENSIVE_OPTIONS': 'Comprehensive options',
    'LIMITED_OPTIONS': 'Limited Options',
    'USER_TYPE': 'User Type',
    'USER_NAME': 'User Name',
    'DOWN_PAYMENT_STATUS': 'Down Payment Status',
    'SELECT_TREATMENTS': 'Select Treatments',
    'SELECT_YEARS': 'Select Years',
    'IMMEDIATE_PATIENT_PAYMENT_AFTER_SIGNING': 'Immediate Patient Payment After Signing Contract',
    'PRICING_LABELS_RENAMED': 'Pricing labels renamed successfully',
    'INVALID_ENTRY': 'Provide a valid entry',
    'NONE': 'None',
    'TERMS_OF_USE': 'Terms Of Use',
    'PRIVACY_POLICY': 'Privacy Policy',
    'NAME_ON_THE_CARD': 'Name on card',
    'STOP_RECURRING_PAYMENT': 'Stop Recurring Payment',
    'RECURRING_PAYMENT_STOPPED_SUCCESS': 'Recurring payment stopped successfully',
    'RECURRING_PAYMENT_STOPPED': 'Recurring payment stopped',
    'RECENT_ONLINE_PAYMENTS': 'Recent Online Payments',
    'PAYMENT_AMOUNT': 'Payment Amount',
    'TOTAL_DAYS_PAST_DUE': 'Total Days Past Due',
    'LAST_PAYMENT_DATE': 'Last Payment Date',
    'TOTAL_BALANCE_DUE': 'Total Balance Due',
    'OFFLINE_PAYMENT': 'Offline Payment',
    'PENDING': 'Pending',
    'PAST_DUE': 'Past Due',
    'PAID': 'Paid',
    'MARK_AS_RECEIVED_OFFLINE_CONFIRMATION': 'The payment will be marked as received offline. Are you sure?',
    'CONFIRM_PAYMENT': 'Confirm Payment',
    'AND': 'and',
    'READ_AND_AGREE': 'I have read and agree to the',
    'SELECT_SUB_CATEGORY': 'Select Sub Category',
    'EDUCATIONAL': 'Educational',
    'TESTIMONIAL': 'Testimonial',
    'QUOTE_EXPIRES_IN': 'Quote Expires in',
    'VIEW_DETAILS': 'View Details',
    'SELECTED_TREATMENT': 'Selected Treatment',
    'PATIENT_RESPONSIBILITY_DETAILS': 'Patient Responsibilty Details',
    'ONLINE_PAYMENT_DETAILS': 'Online Payment Details',
    'RESPONSIBLE_PARTY_BIRTH_LAST_FOUR_PHONE': "Responsible Party's Birth Year + Last Four Digits of Phone Number (YYYYPPPP)",
    'EXAMPLE_CASE_GALLERY': 'Example Case Gallery',
    'VIEW_GALLERY': 'View Gallery',
    'EXAMPLE_GALLERY_DESCRIPTION1': "This Example Case Gallery highlights previously treated patients' results.",
    'EXAMPLE_GALLERY_DESCRIPTION2': "These examples are for patient education purposes only.",
    'EXAMPLE_GALLERY_DESCRIPTION3': "Patient compliance and other factors influence final outcomes for each individual patient.",
    'FORM_SENT': 'Form sent.',
    'ENTER_VALID_DATES': 'Enter valid dates.',
    'PROVIDE_SIGN': 'Provide signature.',
    'ALREADY_SUBMITTED': 'Already submitted.',
    'AGREE_TERMS_CONDITIONS': 'Agree Terms and Conditions',
    'I_APPROVE_TO_RECEIVE': 'I approve to receive',
    'PAYMENT_REMINDERS': 'Payment Reminders',
    'EMAIL_ADDRESS': 'Email Address',
    'REFER_ANOTHER_PATIENT': 'Refer Another Patient',
    'REFER_SUCCESS_MESSAGE': 'Referral Submitted',
    'PAYMENT_PLAN_SUMMARY': 'Payment Plan Summary',
    'CARD_INFORMATION': 'Card Information',
    'PAY': 'Pay',
    'ENTER_CARD_NAME': 'Enter Name on Card',
    'PAY_WITH_CARD': 'Pay with card',
    'ENTER_VALID_DATA': 'Enter valid data',
    'PARENT_FIRST_NAME': 'Parent First Name',
    'PARENT_LAST_NAME': 'Parent Last Name',
    'PARENT_NAME': 'Parent Name',
    'EMAIL_ADDRESS_MISMATCH': 'Email address mismatch',
    'CONFIRM_EMAIL':'Confirm Email',
    'WELCOME_TO': 'Welcome to our',
    'VC_PORTAL': ' Virtual Appointment Portal',
    'SELECT_VIRTUAL_APPOINTMENT_TYPE': 'Select Virtual Appointment Type',
    'SELECT_PRACTICE_LOCATION': 'Select Practice Location',
    'PREV': 'PREV',
    'SELECT_DOCTOR': 'Select Doctor',
    'PATIENT_DETAILS': 'Patient Details',
    'ARE_YOU_USING_ALIGNERS': 'Do you currently wear clear aligners',
    'SNAP_A_FEW_PHOTOS': 'Snap a few photos',
    'WELCOME_PARA': `Please review and accept the Terms of Use, Privacy Policy and Cookie Policy links below in order to proceed with using our online Virtual Appointment Portal.`,
    'WELCOME_PARA_SECOND': 'You must be at least 18 years old to use our Virtual Appointment Portal',
    'APPROVE_ALL_TERMS': 'Approve all terms',
    'SELECT_APPOINTMENT_TYPE': 'Select Appointment Type',
    'MAILING_STREET_ADRESS_1': 'Mailing Street Address 1',
    'MAILING_STREET_ADRESS_2': 'Mailing Street Address 2',
    'RESPONSIBLE_PARTY_CONTACT_INFORMATION': 'Responsible Party Contact Information',
    'PHONE_NO': 'Phone Number',
    'SUCCESS_TEXT_DC': 'Your virtual Discomfort Checkup details have been successfully sent!',
    'SUCCESS_TEXT_DC_PARA_SECOND': 'One of our clinical team members will contact you as soon as possible after reviewing your information.',
    'SUCCESS_TEXT_DC_PARA_THIRD': 'If you do not hear from us within four (4) business hours, please call our office directly at',
    'SUCCESS_TEXT_RC':'Your virtual Retainer Checkup details have been successfully sent!',
    'SUCCESS_TEXT_PC': 'Your virtual Progress Checkup details have been successfully sent!',
    'SUCCESS_TEXT_RC_PARA_SECOND': 'One of our clinical team members will review your progress and provide an update within two (2) business days.',
    'SUCCESS_TEXT_RC_PARA_THIRD': 'If you do not hear from us within a week, please call our office directly at',
    'SUCCESS_TEXT_NC': 'Your virtual consultation details have been successfully sent!',
    'SUCCESS_TEXT_NC_PARA_SECOND': 'After our clinical team reviews your details, one of our treatment coordinators will send you a proposed treatment plan for your review.',
    'SUCCESS_TEXT_NC_PARA_THIRD': 'You should receive your proposed treatment plan & interactive payment calculator within two (2) business days. If you have any questions in the meantime, please feel free to contact our office at:',
    'SELECT_AN_OPTION': 'Select an option',
    'SNAP_ALL_PHOTOS': 'Snap all photos',
    'IS_THE_PATIENT_AN_ADULT_OR_CHILD': 'Is the patient a child or an adult',
    'PREFERRED_TREATMENT_OPTIONS': 'Preferred Treatment Options',
    'PARENT_GUARDIAN_DETAILS': 'Parent/Guardian Details',
    'SELECT_REFERRAL_METHOD': 'Select Referral Method',
    'WHAT_YOUR_MAIN_CONCERN': "What's your main concern?",
    'ANY_OTHER_CONCERNS': "Any other concerns",
    'SELECT_PATIENT_TYPE': 'Select Patient Type',
    'CHILD_FIRST_NAME': 'Child First Name',
    'CHILD_MIDDLE_NAME': 'Child Middle Name',
    'CHILD_LAST_NAME' : 'Child Last Name',
    'CHILD_NAME': 'Child Name',
    'CHILD': 'Child',
    'ADULT': 'Adult',
    'RESPONSIBLE_PARTY_FIRST_NAME' : 'Responsible Party First Name',
    'RESPONSIBLE_PARTY_LAST_NAME': 'Responsible Party Last Name',
    'RESPONSIBLE_PARTY_MIDDLE_NAME':'Responsible Party Middle Name',
    'RESPONSIBLE_PARTY_NAME' : 'Responsible Party Name',
    'REFERRAL_METHOD': 'Referral Method',
    'SELECT_PREFERRED_TREATMENT_OPTIONS': 'Select Preferred Treatment Options',
    'ENTER_NOTES_HERE':'Enter Notes Here',
    'OTHER_CONCERNS_WARNING':'Describe your concerns',
    'SELECT_YOUR_CHIEF_CONCERN':'Select your chief concern',
    'DESCRIBE_ISSUE': 'Please describe your current issue(s)',
    'ISSUE_DESCRIPTION_LABEL': 'Enter issues here',
    'ISSUE_DESCRIPTION_WARNING': 'Describe your issue',
    'EMERGENCY_DISCLAIMER_TEXT': 'If your orthodontic issue is a medical emergency, such as an allergic reaction, bleeding or severe pain, contact our office immediately or go directly to the nearest hospital Emergency Room.',
    'EMERGENCY_TERMS': 'I agree to this disclaimer. The discomfort is not life threatening or causing severe pain.',
    'E_HEADING1': 'Discomfort',
    'E_HEADING2': 'Checkup',
    'DISCLAIMER': 'Disclaimer',
    'SNAP_ATLEAST_ONE': 'To proceed, snap at least two photos including smile',
    'MALOCCLUSION': 'Malocclusion',
    'NPC': 'New Patient Consultation',
    'PC': 'Progress Checkup',
    'RC': 'Retainer Checkup',
    'DC': 'Discomfort Checkup',
    'MOBILE': 'Enter mobile number',
    'NOT_SUPPORTED': 'Our Virtual Consultation application does not support desktop browsers. Please use your mobile handheld device to access the application.',
    'SWITCH_TO_MOBILE': 'smartphone required',
    'SEND_LINK': 'Send link',
    'SEND_LINK_SUCCESS': 'Success! We just texted the link to your mobile phone. Thank you.',
    'LANDSCAPE_WARNING': 'Our virtual appointment application only functions in portrait layout. Please rotate your mobile device to the portrait position.',
    'SELECT_MAIN_CONCERN': 'Select Main Concern',
    'ISSUE_DESCRIPTION':'Issue(s) Description',
    'CLEAR_ALIGNERS': 'Clear Aligners',
    'CLEAR_BRACES' : 'Clear Braces',
    'METAL_BRACES': 'Metal Braces',
    'PRACTICE_DOCTOR': 'Practice Doctor',
    'CHILD_DOB': 'Child DOB',
    'PARENT_DOB': 'Parent DOB',
    'PATIENT_DOB': 'Patient DOB',
    'REVIEW_PATIENT_DETAILS': 'Review Patient Details',
    'COMMENTS': 'Comments',
    'ENTER_COMMENTS_HERE': 'Enter Comments Here',
    'ALIGNERS_OUT': 'Aligners Out',
    'ALIGNERS_IN': 'Aligners In',
    'STEP_MOTHER': 'Step-Mother',
    'STEP_FATHER': 'Step-Father',
    'OTHER': 'Other',
    'ACCESS_RESTRICTED': 'Access Restricted',
    'ACCESS_CURRENTLY_RESTRICTED': 'Access is currently restricted.',
    'PLEASE_CALL': 'Please call',
    'TO_ALERT_US_ISSUE': 'to alert us of this issue.',
    'WE_APOLOGIZE_FOR_INCONVENIENCE': 'We apologize for the inconvenience.',
    'ADD_SECONDARY_RP': 'Add Secondary Responsible Party',
    'SECONDARY_RP_CONFIRM_DELETE': 'Are you sure you want to delete Secondary Responsible Party?',
    'PRIMARY_RP': 'Primary Responsible Party',
    'SECONDARY_RP': 'Secondary Responsible Party',
    'DELETE_RP': 'Delete Responsible Party',
    'SAME_AS_PRIMARY': 'Same as Primary'
};